    // Fetch user's country using an IP API
    $.get("https://ipapi.co/json/", function (data) {
      var userCountry = data.country_code; // Get country code (e.g., "IN" for India)

       if (userCountry !== "IN") {
        // Append popup to body
        $("body").append(`
          <div id="india-popup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.7); display: flex; align-items: center; justify-content: center; z-index: 9999;">
            <div style="background: #fff; padding: 20px; text-align: center; border-radius: 10px; max-width: 400px;">
              <h2>Shopping from outside India?</h2>
              <p>For international orders, pricing, and shipping details, please visit our global website.</p>
              <div class="btnsec-redirect">
                <a class="link1" href="http://drsuformulations.com/">Go to International Site</a>
                <a class="link2" href="javascript:void(0)">Stay on Indian Site</a>
              </div>
            </div>
          </div>
        `);

        // Countdown timer
        // var countdown = 3;
        // var interval = setInterval(function () {
        //   countdown--;
        //   $("#countdown").text(countdown);
        //   if (countdown === 0) {
        //     clearInterval(interval);
        //     window.location.href = "http://drsuformulations.com/"; // Change this URL
        //   }
        // }, 1000);
      }

      
    });


    $(document).on("click", ".link2", function () {
  $("#india-popup").hide();
});

